import React, { useState } from 'react';
import { Check, Minus, Plus, ShieldCheck } from 'lucide-react';
export function CheckoutPage() {
  const [quantities, setQuantities] = useState({
    roundBlue: 1,
    blue: 0
  });
  const [shippingProtection, setShippingProtection] = useState(false);
  const products = {
    roundBlue: {
      name: 'Round head-Blue with export',
      price: 59.87,
      originalPrice: 129.99,
      badge: 'Hot Sale',
      image: 'https://cdn.magicpatterns.com/uploads/ey92rgFEsQ2P3Ce3NGPjUt/image.png'
    },
    blue: {
      name: 'Blue with export',
      price: 59.87,
      originalPrice: 129.99,
      badge: 'Best Seller',
      image: 'https://cdn.magicpatterns.com/uploads/mcnmUkk9rnYT3d8zC31P3E/image.png'
    }
  };
  const toggleProduct = (product: string) => {
    setQuantities(prev => ({
      ...prev,
      [product]: prev[product as keyof typeof prev] > 0 ? 0 : 1
    }));
  };
  const updateQuantity = (product: string, delta: number) => {
    setQuantities(prev => ({
      ...prev,
      [product]: Math.max(0, prev[product as keyof typeof prev] + delta)
    }));
  };
  const calculateSubtotal = () => {
    let subtotal = 0;
    if (quantities.roundBlue > 0) subtotal += products.roundBlue.price * quantities.roundBlue;
    if (quantities.blue > 0) subtotal += products.blue.price * quantities.blue;
    return subtotal;
  };
  const calculateTotal = () => {
    let total = calculateSubtotal();
    if (shippingProtection) total += 1.99;
    return total.toFixed(2);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-37">
      {/* Hero Banner */}
      <div className="w-full" data-id="element-38">
        <img src="https://cdn.magicpatterns.com/uploads/34YKzLRT4puLMTEj3KDedJ/Gemini_Generated_Image_yp5ggbyp5ggbyp5g.jpg" alt="Product banner" className="w-full h-auto object-cover" loading="eager" fetchpriority="high" data-id="element-39" />
      </div>

      {/* Checkout Form */}
      <div className="max-w-6xl mx-auto px-4 py-12" data-id="element-40">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-41">
          {/* Left Column - Bundle Selection */}
          <div data-id="element-42">
            <h2 className="text-2xl font-bold mb-4" data-id="element-43">
              Step 1: Bundle Of Choice
            </h2>

            {/* Product 1 */}
            <div className={`bg-white rounded-lg border-2 ${quantities.roundBlue > 0 ? 'border-blue-500' : 'border-gray-200'} p-4 mb-4`} data-id="element-44">
              <div className="flex gap-4" data-id="element-45">
                <input type="checkbox" checked={quantities.roundBlue > 0} onChange={() => toggleProduct('roundBlue')} className="w-5 h-5 accent-green-600" data-id="element-46" />
                <img src={products.roundBlue.image} alt={products.roundBlue.name} className="w-20 h-20 object-cover rounded" data-id="element-47" />
                <div className="flex-1" data-id="element-48">
                  <div className="flex items-center gap-2 mb-1" data-id="element-49">
                    <span className="bg-yellow-400 text-black text-xs font-bold px-2 py-1 rounded" data-id="element-50">
                      {products.roundBlue.badge}
                    </span>
                  </div>
                  <h3 className="font-semibold mb-1" data-id="element-51">
                    {products.roundBlue.name}
                  </h3>
                  <div className="flex items-center gap-2" data-id="element-52">
                    <span className="text-2xl font-bold text-red-600" data-id="element-53">
                      ${products.roundBlue.price}
                    </span>
                    <span className="text-gray-400 line-through" data-id="element-54">
                      ${products.roundBlue.originalPrice}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2" data-id="element-55">
                  <button onClick={() => updateQuantity('roundBlue', -1)} disabled={quantities.roundBlue === 0} className="w-8 h-8 border rounded flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-56">
                    <Minus className="w-4 h-4" data-id="element-57" />
                  </button>
                  <span className="w-8 text-center font-semibold" data-id="element-58">
                    {quantities.roundBlue}
                  </span>
                  <button onClick={() => updateQuantity('roundBlue', 1)} className="w-8 h-8 border rounded flex items-center justify-center hover:bg-gray-100" data-id="element-59">
                    <Plus className="w-4 h-4" data-id="element-60" />
                  </button>
                </div>
              </div>
            </div>

            {/* Product 2 */}
            <div className={`bg-white rounded-lg border-2 ${quantities.blue > 0 ? 'border-blue-500' : 'border-gray-200'} p-4 mb-4`} data-id="element-61">
              <div className="flex gap-4" data-id="element-62">
                <input type="checkbox" checked={quantities.blue > 0} onChange={() => toggleProduct('blue')} className="w-5 h-5 accent-green-600" data-id="element-63" />
                <img src={products.blue.image} alt={products.blue.name} className="w-20 h-20 object-cover rounded" data-id="element-64" />
                <div className="flex-1" data-id="element-65">
                  <div className="flex items-center gap-2 mb-1" data-id="element-66">
                    <span className="bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-67">
                      {products.blue.badge}
                    </span>
                  </div>
                  <h3 className="font-semibold mb-1" data-id="element-68">{products.blue.name}</h3>
                  <div className="flex items-center gap-2" data-id="element-69">
                    <span className="text-2xl font-bold text-red-600" data-id="element-70">
                      ${products.blue.price}
                    </span>
                    <span className="text-gray-400 line-through" data-id="element-71">
                      ${products.blue.originalPrice}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2" data-id="element-72">
                  <button onClick={() => updateQuantity('blue', -1)} disabled={quantities.blue === 0} className="w-8 h-8 border rounded flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-73">
                    <Minus className="w-4 h-4" data-id="element-74" />
                  </button>
                  <span className="w-8 text-center font-semibold" data-id="element-75">
                    {quantities.blue}
                  </span>
                  <button onClick={() => updateQuantity('blue', 1)} className="w-8 h-8 border rounded flex items-center justify-center hover:bg-gray-100" data-id="element-76">
                    <Plus className="w-4 h-4" data-id="element-77" />
                  </button>
                </div>
              </div>
            </div>

            {/* Shipping Protection */}
            <div className="flex items-center gap-2 mb-6" data-id="element-78">
              <input type="checkbox" checked={shippingProtection} onChange={e => setShippingProtection(e.target.checked)} className="w-5 h-5 accent-green-600" data-id="element-79" />
              <span className="text-sm" data-id="element-80">Shipping protection $1.99</span>
            </div>

            {/* Order Summary */}
            <div className="bg-white rounded-lg border-2 border-gray-200 p-6" data-id="element-81">
              <h3 className="text-xl font-bold mb-4" data-id="element-82">Order Summary</h3>

              <div className="space-y-3" data-id="element-83">
                {/* Products */}
                {quantities.roundBlue > 0 && <div className="flex justify-between items-center" data-id="element-84">
                    <span className="text-gray-700" data-id="element-85">
                      {products.roundBlue.name} x {quantities.roundBlue}
                    </span>
                    <span className="font-semibold" data-id="element-86">
                      $
                      {(products.roundBlue.price * quantities.roundBlue).toFixed(2)}
                    </span>
                  </div>}

                {quantities.blue > 0 && <div className="flex justify-between items-center" data-id="element-87">
                    <span className="text-gray-700" data-id="element-88">
                      {products.blue.name} x {quantities.blue}
                    </span>
                    <span className="font-semibold" data-id="element-89">
                      ${(products.blue.price * quantities.blue).toFixed(2)}
                    </span>
                  </div>}

                {/* Shipping */}
                <div className="flex justify-between items-center pt-3 border-t" data-id="element-90">
                  <span className="text-gray-700" data-id="element-91">Shipping</span>
                  <span className="font-semibold text-green-600" data-id="element-92">
                    FREE SHIPPING
                  </span>
                </div>

                {/* Shipping Protection */}
                {shippingProtection && <div className="flex justify-between items-center" data-id="element-93">
                    <span className="text-gray-700" data-id="element-94">Shipping Protection</span>
                    <span className="font-semibold" data-id="element-95">$1.99</span>
                  </div>}

                {/* Total */}
                <div className="flex justify-between items-center pt-3 border-t-2 border-gray-300" data-id="element-96">
                  <span className="text-xl font-bold" data-id="element-97">Total</span>
                  <span className="text-2xl font-bold text-blue-900" data-id="element-98">
                    ${calculateTotal()}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Payment */}
          <div data-id="element-99">
            <h2 className="text-2xl font-bold mb-4" data-id="element-100">
              Step 2: Payment Information
            </h2>

            <div className="bg-white rounded-lg p-6 shadow-lg" data-id="element-101">
              {/* Payment Buttons */}
              <button className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-4 rounded-lg mb-3 flex items-center justify-center gap-2" data-id="element-102">
                Pay with <span className="text-blue-600" data-id="element-103">PayPal</span>
              </button>

              <button className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 rounded-lg mb-4 flex items-center justify-center gap-2" data-id="element-104">
                Pay with <span className="font-black" data-id="element-105">◐</span>link
              </button>

              <div className="text-center text-sm text-gray-500 mb-4" data-id="element-106">
                OR CHECKOUT WITH OTHER METHODS
              </div>

              {/* Checkout Button */}
              <button onClick={() => window.location.href = 'https://knovastore.com/checkouts/cn/hWN60ANGLE7Ef6e1fyioU5qc/en-us?_r=AQABcxqjBx-pQ-u0kHYN0xH13PCMW4zuiZ7fFVeO-zy9jxg&adminUrl=admin.shopify.com&auto_redirect=false&cart_link_id=ZpnRv675&edge_redirect=true&editedAt=2025-11-23T08%3A22%3A13Z&isPublished=true&preview_theme_id=156362834139&profileName=Knova+Store+configuration&profile_preview_token=eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJxdW1wdngteGIubXlzaG9waWZ5LmNvbSIsImF1ZCI6InF1bXB2eC14Yi5teXNob3BpZnkuY29tIiwibmJmIjoxNzY1NDc4NDUxLCJjaGVja291dF9wcm9maWxlX2lkIjozNTE5MzE2MTg3LCJjaGVja291dF9wcm9maWxlX3B1Ymxpc2hlZCI6dHJ1ZSwidXNlcl9pZCI6MTAyMTA5MDUzMTQ3LCJleHAiOjE3NjU0ODIwNTF9.e4TfHlee3JT68k_xj-aIdGTLBkXo5N_e6BUhdP_mUE8&skip_shop_pay=true'} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 rounded-lg mb-6 text-lg" data-id="element-107">
                Checkout - ${calculateTotal()}
              </button>

              {/* Security Section */}
              <div className="border-t pt-4" data-id="element-108">
                <div className="text-center font-bold mb-3 flex items-center justify-center gap-2" data-id="element-109">
                  <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-110" />
                  SECURE PAYMENT GUARANTEED
                </div>
                <p className="text-sm font-semibold mb-3" data-id="element-111">
                  Pay confidently with our secure methods
                </p>
                <div className="space-y-2 text-sm text-gray-700" data-id="element-112">
                  <div className="flex items-start gap-2" data-id="element-113">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-114" />
                    <span data-id="element-115">Card information is secure and uncompromised</span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-116">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-117" />
                    <span data-id="element-118">
                      Sakerplus follows the Payment Card Industry Data Security
                      Standard (PCI DSS) and other security standards when
                      handling card data
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-119">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-120" />
                    <span data-id="element-121">All data is encrypted</span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-122">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-123" />
                    <span data-id="element-124">Sakerplus never sells your card information</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}